module.exports = "<rnpl-linear-tree-branch [tree]=\"tree\" [entity]=\"entity\" [isLoading]=\"isLoading\"></rnpl-linear-tree-branch>\n"